module.exports = __webpack_public_path__ + "static/img/three@2x.45ae8735.png";